module.exports = __webpack_public_path__ + "static/media/icon-elo.564394ea.png";